<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import {
    updateUrlParam,
    activitiesConfig,
    selectedActivityIndex,
  } from "../store/AppState";
  import { suppressSounds } from "../utils/AudioManager";

  let Modal: HTMLElement;
  let ModalSubtitle: HTMLElement;

  let src: string;
  let title: string;

  export let isOtherActivity: boolean = false;
  export let otherActivitySrc: string = "";
  export let otherActivityTitle: string = "";
  export let onOtherActivityClose: null | (() => void) = null;

  const setClosingStyles = () => {
    Modal.style.width = "1dvw";
    Modal.style.height = "1dvh";
    Modal.style.top = "50%";
    Modal.style.left = "50%";
    Modal.style.right = "50%";
    Modal.style.bottom = "50%";
    ModalSubtitle.style.fontSize = "0rem";
  };

  const keydownListener = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      handleClose();
    }
  };

  const handleClose = () => {
    setClosingStyles();
    suppressSounds(false);
    setTimeout(() => {
      updateUrlParam("aktivita", null);
      window.location.hash = "";
      if (onOtherActivityClose !== null) {
        onOtherActivityClose();
      }
    }, 300);
  };

  onMount(() => {
    if (isOtherActivity) {
      src = otherActivitySrc;
      title = otherActivityTitle;
    } else {
      if ($selectedActivityIndex !== null) {
        src = $activitiesConfig[$selectedActivityIndex].src;
        title = $activitiesConfig[$selectedActivityIndex].title;
      }
    }
    suppressSounds(true);
    window.addEventListener("keydown", keydownListener);
    setTimeout(() => {
      Modal.style.width = "100dvw";
      Modal.style.height = "100dvh";
      Modal.style.top = "0";
      Modal.style.left = "0";
      Modal.style.right = "0";
      Modal.style.bottom = "0";
      ModalSubtitle.style.fontSize = "1.6875rem";
    }, 100);
  });

  onDestroy(() => {
    window.removeEventListener("keydown", keydownListener);
    src = "";
    title = "";
  });
</script>

<div bind:this={Modal} class="modal-window">
  <div class="modal-box">
    <div class="modal-content">
      <button class="close-button" on:pointerup={handleClose}
        ><img
          src={`${__PUBLIC_PATH__}images/icon-close-white.svg`}
          alt="close"
        /></button
      >
      <iframe
        class="iframe"
        {src}
        allow="autoplay"
        sandbox="allow-presentation allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-same-origin allow-scripts allow-popups allow-forms"
        allowfullscreen
        title="modal-iframe"
        width="100%"
        height="100%"
      />
      <p bind:this={ModalSubtitle}>
        {title}
      </p>
    </div>
  </div>
</div>

<style>
  .modal-window {
    position: fixed;
    top: 50%;
    left: 50%;
    bottom: 50%;
    right: 50%;
    width: 1dvw;
    height: 1dvh;
    z-index: 10000000;
    background: hsla(208, 42%, 17%, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s ease-in;
  }

  .modal-box {
    width: 80%;
    max-height: 900px;
    max-width: 1600px;
    position: relative;
    flex-shrink: 0;
    margin: auto;
  }

  .modal-content {
    position: relative;
    padding-bottom: 56.25%;
    font-size: 0rem;
    color: white;
    text-align: left;
  }

  .iframe {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
    border: none;
  }

  .modal-content p {
    font-size: 0rem;
    font-family: "source-sans-pro", sans-serif;
    line-height: 1.875rem;
    transition: 0.3s ease-in;
    position: absolute;
    top: 100%;
  }

  .close-button {
    all: unset;
    position: absolute;
    top: -0.5rem;
    right: -4rem;
    cursor: pointer;
  }
</style>
